let scrolled = false;

export const hasScrolled = () => scrolled;

export const markAsScrolled = () => {
  scrolled = true;
};
